<template>
  <PageWrapper>
    <template v-slot:content>
      <div class="custom-table" v-if="showPage">
        <el-button type="primary" size="small" class="el-icon-plus custom-btn" @click="handleAdd">新增用户</el-button>
        <el-table border fit  highlight-current-row class="customer-table" :data="list">
          <el-table-column label="序号" prop="id"></el-table-column>
          <el-table-column label="姓名" prop="rname"></el-table-column>
          <el-table-column label="账号" prop="username"></el-table-column>
          <el-table-column label="创建时间" prop="settime"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="primary" size="small" @click="handleEdit(scope)"
                         class="el-icon-edit-outline"
              >
                编辑
              </el-button>
              <el-popconfirm
                iconColor="red"
                @confirm="handleDelete(scope.row,scope.$index)"
                title="确认删除此条数据吗？"
              >
                <el-button slot="reference" type="danger" size="small" class="el-icon-delete">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                       :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]" :page-size="selectPage.pageSize"
                       background
                       layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                       style="margin-top: 14px;margin-bottom:14px"
        >
        </el-pagination>
      </div>
      <el-empty description="暂无权限查看数据" v-else class="customer-category_empty" />
      <Edit :dialog="dialog" :form-data="editFormData"  @submit="handleSubmit" :type="type" @close="handleClose" />
    </template>
  </PageWrapper>
</template>
<script>
import { computed, defineComponent, getCurrentInstance, onMounted, reactive, ref } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue';
import Edit from "./edit.vue";
import request from '@/utils/request';
import { Message } from 'element-ui';

export default defineComponent({
  components: {PageWrapper,Edit},
  setup() {
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20,
    })
    const allNum = ref(1)
    const dialog = ref(false)
    const type = ref("")
    const editFormData = ref({})
    const list = ref([])
    const keyId = ref(null)

    const word = computed(()=>{
      if(!showAll.value){
        return '展开'
      }else{
        return '收起'
      }
    })
    const handleAdd = () => {
      dialog.value = true;
      type.value = "add";
      editFormData.value = {}
    }
    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getUser()
    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getUser()
    }


    const handleEdit = (scope) => {
      dialog.value = true
      type.value = "edit"
      keyId.value = scope.row.id
      editFormData.value = { ...editFormData.value, ...scope.row }
    }

    const handleDelete = (scope, index) =>{
      request({
        url: 'user_management_delete.yy',
        method: 'post',
        data: { id: scope.id }
      }).then(res =>{
        if(res.code == 200) deleteRow(index)
      }).catch(err =>{
        Message({message: err,type: 'error'})
      })
    }

    const deleteRow = (index)=> {
      list.value.splice(index, 1)
    }

    onMounted(() => {
      getUser()
    })

    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const showPage = ref(false)
    const getUser = () => {
      request({
        url: 'user_management_list.yy',
        method: 'post',
        data: {username: username}
      }).then((res) => {
        const {code, data,qz_type} = res
        if(code == 200) {
          list.value = data
          if(qz_type == 1){
            showPage.value = true
          }else{
            showPage.value = false
          }
        }
      })
    }

    const handleSubmit = (form) => {
      let data;
      if(type.value === 'add') {
        data = request({
          url: 'user_management_insert.yy',
          method: 'post',
          data: form
        })
      }else{
        data = request({
          url: 'user_management_update.yy',
          method: 'post',
          data: {id: keyId.value,...form}
        })
      }
      data.then(res=>{
        if(res.code == 200){
           dialog.value = false
           getUser()
        }
      })
    }

    const handleClose = () => {
      dialog.value = false
      editFormData.value = {}
    }

    return {
      showPage,
      username,
      showAll,
      dialog,
      editFormData,
      type,
      allNum,
      selectPage,
      word,
      list,
      keyId,
      handleClose,
      handleAdd,
      pageSizeChange,
      pageCurrentChange,
      handleSubmit,
      handleEdit,
      handleDelete,
      deleteRow
    };
  }
})
</script>
<style scoped>
.el-icon-edit-outline {
  margin-right: 10px;
}
.el-icon-delete {
  span {
    margin-left: 4px;
  }
}
.customer-category_empty {
  height: calc(100vh - 130px);
}
</style>

